import { configureCityAPI } from "./city-api";
import { configureApeAPI } from "./ape-api";
import { configureHealthEstimateAPI } from "./health-estimate-api";
import { configureConfigurationAPI } from "./configuration-api";

const BASE_URL = `/o/mutelios-ws`;

const cityApi = configureCityAPI({ baseUrl: BASE_URL });
const apeApi = configureApeAPI({ baseUrl: BASE_URL });
const healthHestimateApi = configureHealthEstimateAPI({ baseUrl: BASE_URL });
const configurationAPI = configureConfigurationAPI({ baseUrl: BASE_URL });

const api = {
    ...cityApi,
    ...apeApi,
    ...healthHestimateApi,
    ...configurationAPI
};


export default api;